import React from "react";
import { motion } from "framer-motion";
import { SectionHeading } from "./shared";
import { PROCESS } from "../data";

export const Process = () => {
  return (
    <section className="bg-ink py-20 lg:py-28" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          center
          light
          eyebrow="Procesul de lucru"
          title="Cum lucrăm împreună"
          subtitle="Un proces clar și transparent, de la prima discuție până la creșterea afacerii tale."
        />

        <div className="mt-16 relative">
          <div className="hidden lg:block absolute top-9 left-0 right-0 h-px bg-white/10" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-4">
            {PROCESS.map((p, i) => (
              <motion.div
                key={p.step}
                data-testid={`process-step-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="relative"
              >
                <div className="relative z-10 flex h-[72px] w-[72px] items-center justify-center rounded-2xl bg-brand text-white text-2xl font-extrabold shadow-lift">
                  {p.step}
                </div>
                <h3 className="mt-5 text-base font-semibold text-white">{p.title}</h3>
                <p className="mt-2 text-sm text-white/60 leading-relaxed">{p.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
